import { Users } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const usersNavigation: NavItem[] = [
  { to: '/users', labelKey: 'nav.users', group: 'nav.groups.users', icon: Users, permission: 'users.view' },
]
